import { useEffect } from 'react';
import { useAuthStore } from '../../stores/useAuthStore';

export function useAuthStorageSync() {
  useEffect(() => {
    const handleStorage = () => {
      // Sync Zustand store when storage changes (like logout/login in another tab)
      useAuthStore.getState().refreshAuthFromStorage();
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);
}
